// https://vuex.vuejs.org/en/getters.html

import { cloneDeep } from 'lodash-es';

export default {
  isAccountInfoLoading: state => {
    return state.accountInfoLoading;
  },
  appVersion: state => {
    return state.appVersion;
  },
  checkRanOutOfImportQuota: (_, getters) => {
    if (getters.importsLeft == null || getters.importsLeft > 0) {
      return false;
    } else {
      return true;
    }
  },
  percentageOrdersSynced: state => {
    if (!state.installationInfo.shopifyOrdersCount) {
      return 0;
    }
    return Math.ceil(
      (100 * state.installationInfo.currentOrdersCount) / state.installationInfo.shopifyOrdersCount
    );
  },
  percentageProductsSynced: state => {
    if (!state.installationInfo.shopifyProductsCount) {
      return 0;
    }
    return Math.ceil(
      (100 * state.installationInfo.currentProductsCount) /
        state.installationInfo.shopifyProductsCount
    );
  },
  numFinishedInstallationSteps: state => {
    const arraySteps = [
      state.installationInfo.finishedImportReviews,
      state.installationInfo.finishedAutomateReviews,
      state.installationInfo.finishedCustomizeWidget,
      state.installationInfo.finishedSetupCoupon,
      state.installationInfo.finishedReviewUsOnAppStore,
    ];

    let doneSteps = 0;

    arraySteps.forEach(step => {
      if (step === true) {
        doneSteps++;
      }
    });

    return doneSteps;
  },
  //820 notes: unused variable removed
  numTotalInstallationSteps: state => {
    const arraySteps = [
      state.installationInfo.finishedImportReviews,
      state.installationInfo.finishedAutomateReviews,
      state.installationInfo.finishedCustomizeWidget,
      state.installationInfo.finishedSetupCoupon,
      state.installationInfo.finishedReviewUsOnAppStore,
    ];
    return arraySteps.length;
  },
  completedOnboarding: (state, getters) => {
    return getters.numFinishedInstallationSteps === getters.numTotalInstallationSteps;
  },
  hasCompletedStep: state => stepId => {
    switch (stepId) {
      case 'finished_customize_widget':
        return state.installationInfo.finishedCustomizeWidget;
      case 'finished_setup_coupon':
        return state.installationInfo.finishedSetupCoupon;
      case 'finished_import_reviews':
        return state.installationInfo.finishedImportReviews;
      case 'finished_automate_reviews':
        return state.installationInfo.finishedAutomateReviews;
      case 'finished_review_us_on_app_store':
        return state.installationInfo.finishedReviewUsOnAppStore;
    }
    return false;
  },
  hasCompletedOnboardingStep: state => stepId => {
    return state.accountInfo.onboardingSteps[stepId.toString()];
  },
  // installation
  numTotalOnboardingInstallationSteps: state => {
    const arraySteps = [
      state.accountInfo?.onboardingSteps['widgetInstallation'],
      state.accountInfo?.onboardingSteps['widgetCustomization'],
    ];
    return arraySteps.length;
  },
  numTotalInstallationStepsLeft: state => {
    const arraySteps = [
      state.accountInfo?.onboardingSteps['widgetInstallation'],
      state.accountInfo?.onboardingSteps['widgetCustomization'],
    ];
    let doneSteps = 0;

    arraySteps.forEach(step => {
      if (step === false) {
        doneSteps++;
      }
    });

    return doneSteps;
  },
  installationProgressBar: (state, getters) => {
    const completed =
      getters.numTotalOnboardingInstallationSteps - getters.numTotalInstallationStepsLeft;
    return completed / getters.numTotalOnboardingInstallationSteps;
  },
  // import reviews
  numTotalOnboardingReviewsSteps: state => {
    const arraySteps = [
      state.accountInfo?.onboardingSteps['productReviewsImport'],
      state.accountInfo?.onboardingSteps['shopReviewsImport'],
      state.accountInfo?.onboardingSteps['migrateReviews'],
    ];
    return arraySteps.length;
  },
  numTotalReviewsStepsLeft: state => {
    const arraySteps = [
      state.accountInfo?.onboardingSteps['productReviewsImport'],
      state.accountInfo?.onboardingSteps['shopReviewsImport'],
      state.accountInfo?.onboardingSteps['migrateReviews'],
    ];
    let doneSteps = 0;

    arraySteps.forEach(step => {
      if (step === false) {
        doneSteps++;
      }
    });

    return doneSteps;
  },
  reviewsProgressBar: (state, getters) => {
    const completed = getters.numTotalOnboardingReviewsSteps - getters.numTotalReviewsStepsLeft;
    return completed / getters.numTotalOnboardingReviewsSteps;
  },
  // request for past orders
  numTotalOnboardingRequestsSteps: state => {
    const arraySteps = [
      state.accountInfo?.onboardingSteps['configureRequests'],
      state.accountInfo?.onboardingSteps['sendRequestsToPastOrders'],
    ];
    return arraySteps.length;
  },
  numTotalRequestsStepsLeft: state => {
    const arraySteps = [
      state.accountInfo?.onboardingSteps['configureRequests'],
      state.accountInfo?.onboardingSteps['sendRequestsToPastOrders'],
    ];
    let doneSteps = 0;

    arraySteps.forEach(step => {
      if (step === false) {
        doneSteps++;
      }
    });

    return doneSteps;
  },
  requestsProgressBar: (state, getters) => {
    const completed = getters.numTotalOnboardingRequestsSteps - getters.numTotalRequestsStepsLeft;
    return completed / getters.numTotalOnboardingRequestsSteps;
  },
  // features
  numTotalOnboardingFeaturesSteps: state => {
    const arraySteps = [
      state.accountInfo?.onboardingSteps['unverifiedReviews'],
      state.accountInfo?.onboardingSteps['smartReviews'],
      state.accountInfo?.onboardingSteps['qAndA'],
      state.accountInfo?.onboardingSteps['linkProducts'],
      state.accountInfo?.onboardingSteps['linkShops'],
    ];
    return arraySteps.length;
  },
  numTotalFeaturesLeft: state => {
    const arraySteps = [
      state.accountInfo?.onboardingSteps['unverifiedReviews'],
      state.accountInfo?.onboardingSteps['smartReviews'],
      state.accountInfo?.onboardingSteps['qAndA'],
      state.accountInfo?.onboardingSteps['linkProducts'],
      state.accountInfo?.onboardingSteps['linkShops'],
    ];
    let doneSteps = 0;

    arraySteps.forEach(step => {
      if (step === false) {
        doneSteps++;
      }
    });

    return doneSteps;
  },
  featuresProgressBar: (state, getters) => {
    const completed = getters.numTotalOnboardingFeaturesSteps - getters.numTotalFeaturesLeft;
    return completed / getters.numTotalOnboardingFeaturesSteps;
  },
  finishedOnboardingSteps: state => {
    const arraySteps = [
      state.accountInfo?.onboardingSteps['widgetInstallation'],
      state.accountInfo?.onboardingSteps['widgetCustomization'],
      state.accountInfo?.onboardingSteps['productReviewsImport'],
      state.accountInfo?.onboardingSteps['shopReviewsImport'],
      state.accountInfo?.onboardingSteps['migrateReviews'],
      state.accountInfo?.onboardingSteps['configureRequests'],
      state.accountInfo?.onboardingSteps['sendRequestsToPastOrders'],
      state.accountInfo?.onboardingSteps['unverifiedReviews'],
      state.accountInfo?.onboardingSteps['smartReviews'],
      state.accountInfo?.onboardingSteps['qAndA'],
      state.accountInfo?.onboardingSteps['linkProducts'],
      state.accountInfo?.onboardingSteps['linkShops'],
    ];
    let doneSteps = 0;

    arraySteps.forEach(step => {
      if (step === true) {
        doneSteps++;
      }
    });
    return doneSteps === arraySteps.length;
  },
  canAddSmartReviewsOnPlan: state => planId => {
    return state.accountInfo.smartReviewsAllowedPlans.includes(planId);
  },
  canAddBazaarvoiceOnPlan: state => planId => {
    return state.accountInfo.bazaarvoiceAllowedPlans.includes(planId);
  },
  checkPermission: state => permissionName => {
    if (Array.isArray(permissionName)) {
      return state.accountInfo.permissions.some(permission => {
        return permissionName.includes(permission);
      });
    } else {
      return state.accountInfo.permissions.indexOf(permissionName) > -1;
    }
  },
  getPermissionPlans: state => permissionName => {
    let mapping = Object.values(state.accountInfo.permissionMapping);
    mapping = mapping.sort((a, b) => a.price - b.price);
    const plans = new Set();
    for (const plan of mapping) {
      if (plan.permissions.indexOf(permissionName) > -1) {
        plans.add(plan.name);
      }
    }
    return Array.from(plans);
  },
  isPermissionInPlan: state => (permissionName, planId) => {
    if (
      planId &&
      state.accountInfo.permissionMapping[planId] &&
      state.accountInfo.permissionMapping[planId].permissions.indexOf(permissionName) > -1
    ) {
      return true;
    }
    return false;
  },
  isPermissionInCurrentPlan: state => permissionName => {
    if (state.accountInfo.permissions.indexOf(permissionName) > -1) {
      return true;
    }
    return false;
  },
  getAddons: () => addonNames => {
    for (const addon of Array.isArray(addonNames) ? addonNames : [addonNames]) {
      switch (addon) {
        case 'link_shops_single':
        case 'link_shops_double':
        case 'link_shops_unlimited':
          return ['Shop links'];
        case 'smart_reviews':
          return ['Smart reviews'];
      }
    }
  },
  getRequiredAndOptionalMergeTagsFormatted: state => templateName => {
    return state.accountInfo.mergeTagsPerTemplate[templateName]?.required
      .concat(state.accountInfo.mergeTagsPerTemplate[templateName]?.optional)
      .map(a => `{${a}}`)
      .join(' ');
  },
  getRequiredAndOptionalMergeTags: state => templateName => {
    return state.accountInfo.mergeTagsPerTemplate[templateName]?.required.concat(
      state.accountInfo.mergeTagsPerTemplate[templateName]?.optional
    );
  },
  getRequiredMergeTags: state => templateName => {
    return state.accountInfo.mergeTagsPerTemplate[templateName]?.required || [];
  },
  getOptionalMergeTags: state => templateName => {
    return state.accountInfo.mergeTagsPerTemplate[templateName]?.optional || [];
  },
  userFirstName: state => {
    if (state.accountInfo.shopOwnerName) {
      return state.accountInfo.shopOwnerName.split(' ')[0];
    }
    return '';
  },
  userLastName: state => {
    if (state.accountInfo.shopOwnerName) {
      return state.accountInfo.shopOwnerName.split(' ').slice(-1).join(' ');
    }
    return '';
  },
  segmentObject: state => {
    let object = {};
    if (state.accountInfo) {
      const now = new Date();
      const createdTs = new Date(state.accountInfo.createdTs);
      const minutesSinceInstall = Math.round((now.getTime() - createdTs.getTime()) / 60000);

      object = {
        shopPlatformId: state.accountInfo.shopPlatformId,
        shopId: state.accountInfo.shopId,
        email: state.accountInfo.shopOwnerEmail,
        shopName: state.accountInfo.shopName,
        shopOwnerName: state.accountInfo.shopOwnerName,
        planType: state.accountInfo.planType,
        createdTs: state.accountInfo.createdTs,
        minutesSinceInstall: minutesSinceInstall,
        planName: state.accountInfo.planName,
        planPrice: state.accountInfo.planPrice,
        currentOrdersCount: state.accountInfo.currentOrdersCount,
        shopifyPlanName: state.accountInfo.shopifyPlanName,
        shopReviewStats: state.accountInfo.shopReviewStats,
      };
    }
    return cloneDeep(object);
  },
  daysSinceOpinewInstallation: state => {
    const sessionCreatedDate = new Date(state.accountInfo.createdTs);
    const today = new Date(Date.now());
    const dayInMilliseconds = 1000 * 3600 * 24;
    const timeBetweenDates = today.getTime() - sessionCreatedDate.getTime();
    return timeBetweenDates / dayInMilliseconds;
  },
  daysSinceShopCreation: state => {
    const shopCreatedDate = new Date(state.accountInfo.shopCreationDate);
    const today = new Date(Date.now());
    const dayInMilliseconds = 1000 * 3600 * 24;
    const timeBetweenDates = today.getTime() - shopCreatedDate.getTime();
    return timeBetweenDates / dayInMilliseconds;
  },
  daysForNextBilling: state => {
    const shopBillingDate = new Date(state.accountInfo.billingDate);
    const today = new Date(Date.now());
    const dayInMilliseconds = 1000 * 3600 * 24;
    if (state.accountInfo.planType === 'year' || state.accountInfo.planName === 'Free') {
      const finalDayOfMonth = new Date();
      // last day of current month
      finalDayOfMonth.setMonth(today.getMonth() + 1);
      finalDayOfMonth.setDate(0);
      // days till renewal = days left in current month
      const timeBetweenDates = finalDayOfMonth.getTime() - today.getTime();
      return Math.round(timeBetweenDates / dayInMilliseconds);
    } else {
      const timeBetweenDates = shopBillingDate.getTime() - today.getTime();
      const totalDaysLeft = timeBetweenDates / dayInMilliseconds;
      if (totalDaysLeft <= 0) {
        return 30;
      } else {
        return Math.round(totalDaysLeft);
      }
    }
  },
  importsLeft: state => {
    return state.accountInfo.reviewImportQuotaLeft;
  },
  shopCurrencySymbol: state => {
    const symbolSource = new Intl.NumberFormat('ja-JP', {
      style: 'currency',
      currency: state.accountInfo.shopCurrency,
    }).format(1);

    const currencySymbol = [];

    for (let i = 0; i < symbolSource.length; i++) {
      if (symbolSource.charAt(i) === '1') {
        break;
      }
      currencySymbol.push(symbolSource.charAt(i));
    }

    return currencySymbol.join('');
  },
  subscriptionCurrencySymbol: state => {
    const symbolSource = new Intl.NumberFormat('ja-JP', {
      style: 'currency',
      currency: state.accountInfo.shopSubscriptionCurrency || 'USD',
    }).format(1);

    const currencySymbol = [];

    for (let i = 0; i < symbolSource.length; i++) {
      if (symbolSource.charAt(i) === '1') {
        break;
      }
      currencySymbol.push(symbolSource.charAt(i));
    }

    return currencySymbol.join('');
  },
};
